// Every path the portal asks of back-ratings, once each.
//
// English spelling under the users/ prefix since back-ratings #39 (its
// handoff of 2026-09-24, phase 1 of step 7). Over there both spellings and
// both prefixes still resolve, on the same view and with the same body, so
// this file is what moves the portal rather than a change in each caller.
// The back removes the Spanish routes only when we tell it nothing calls
// them; `reportes` stays until the legacy is shut down.
//
// JSON keys and the Spanish sentences of an error did not move with the
// routes: those are phases 2 and 3, and arrive as their own handoffs.
//
// A path here has no leading slash and no query string; the caller joins it
// to API_DEFAULT and adds what it needs.
export const API = {
  auth: 'users/auth',
  refreshToken: 'users/refresh-token',
  logout: 'users/logout',

  viewers: 'users/viewers',
  reports: 'users/reports',
  signedUrl: (id) => `users/reports/${id}/signed-url`,
  // The three documents that are not a client's report, by key: the portal
  // never sends a path, so it cannot ask the back to sign an object of its
  // choosing (back-ratings #53).
  documentUrl: (key) => `users/documents/${key}/signed-url`,

  processes: 'users/processes',
  killProcess: 'users/kill-process-by-id',
  scopes: 'users/scopes',
  netReach: 'users/net-reach',

  // The dates a consumption table covers, and the channels and programmes
  // of the scopes forms. -nu names the Nuevo Universo, which is a name, not
  // a Spanish word to translate.
  rangeDates: 'users/range-dates',
  rangeDatesNu: 'users/range-dates-nu',
  channelProgram: 'users/channel-program',
  channelProgramAlter: 'users/channel-program-alter',
  channelProgramNu: 'users/channel-program-nu',
  channelProgramAlterNu: 'users/channel-program-alter-nu',
  channelProgramClean: 'users/channel-program-clean',
  channelProgramCleanNu: 'users/channel-program-clean-nu',

  // Not part of step 7: the Power BI endpoints keep their own prefix.
  embedToken: 'pbi-auth/pbi-embed-token',
};
